export default "__VITE_ASSET__ClH9PAh5__"